import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicOutOfRoom({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 7.522a.75.75 0 01-.248.558l-1.35 1.215-.675.607a.75.75 0 11-1.004-1.114l.572-.515H10.25a.75.75 0 010-1.5h2.546l-.573-.516a.75.75 0 111.004-1.114l.675.607 1.35 1.215a.75.75 0 01.248.558zM4.958 2.75l1.413.811c.544.312.879.891.879 1.518v7.171h3.25a.25.25 0 00.25-.25v-.2a.75.75 0 011.5 0v.2a1.75 1.75 0 01-1.75 1.75H7.25v.757a1.25 1.25 0 01-1.872 1.084l-3.75-2.152A1.75 1.75 0 01.75 11.92V2.494c0-.783.689-1.327 1.394-1.244H10.5c.966 0 1.75.784 1.75 1.75v.2a.75.75 0 01-1.5 0V3a.25.25 0 00-.25-.25H4.958zM5.75 13V5.079a.25.25 0 00-.126-.217L2.25 2.925v8.996c0 .09.048.172.126.217l3.374 1.937V13z"
      />
    </svg>
  );
}

SvgBasicOutOfRoom.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicOutOfRoom.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicOutOfRoom svgRef={ref} {...props} />);
export default ForwardRef;
